import React from 'react';
import { Box } from '@mui/material';
import CardWithBoxShadow from '../../common/components/CardWithBoxShadow';
import CancelSubscriptionButton from './CancelSubscriptionButton';
import IapNotice from './IapNotice';
import SubscriptionDetails from './SubscriptionDetails';
import TeamLogo from './TeamLogo';
import { SUBSCRIPTION_STATUS } from '../constants';
import { Subscription } from '../hooks/useMarketplaceSubscriptions';

interface Props {
    subscription: Subscription;
    onCancelled: () => void;
    onError: (message: string) => void;
}

export default function MarketplaceSubscriptionCard({
    subscription,
    onCancelled,
    onError,
}: Props) {
    const showCancelButton =
        !subscription.isIap
        && !subscription.isProgram
        && (subscription.status === SUBSCRIPTION_STATUS.ACTIVE || subscription.status === SUBSCRIPTION_STATUS.OVERDUE);

    return (
        <CardWithBoxShadow >
            <Box margin={2} display="flex" alignItems="center" flexDirection="column">
                <Box display="flex" flexDirection="row" alignItems="flex-start" justifyContent="space-between" width="100%">
                    <TeamLogo logo={subscription.logo} title={subscription.name} />
                    <SubscriptionDetails subscription={subscription} />
                </Box>
                {subscription.isIap && <IapNotice />}
                {showCancelButton && (
                    <CancelSubscriptionButton
                        subscriptionId={subscription.id}
                        subscriptionName={subscription.name}
                        onCancelled={onCancelled}
                        onError={onError}
                    />
                )}
            </Box>
        </CardWithBoxShadow>
    );
}
